import { Box, Typography } from '@mui/material';
import { DialogTitle, CustomButton } from '../../../../common/components';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PrintIcon from '@mui/icons-material/Print';

const StatisticsDialogTitle = ({
  title,
  onExportExcel,
  onExportPDF,
  onClose,
  excelLabel = "XLSX",
  pdfLabel = "PDF",
  closeLabel = "X",
  showExcelButton = true,
  showPdfButton = true,
  showSeparator = false,
  ...props
}) => {
  return (
    <DialogTitle showSeparator={showSeparator} {...props}>
      <Box sx={{ position: 'relative', width: '100%' }}>
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            top: 0,
            display: 'flex',
            gap: 1,
          }}
        >
          {showExcelButton && (
            <CustomButton
              variant="info"
              onClick={onExportExcel}
              startIcon={<DescriptionOutlinedIcon />}
            >
              {excelLabel}
            </CustomButton>
          )}
          {showPdfButton && (
            <CustomButton 
              variant="info" 
              onClick={onExportPDF} 
              startIcon={<PrintIcon />}
            >
              {pdfLabel}
            </CustomButton>
          )}
        </Box>

        <Box sx={{ textAlign: 'center', px: 20 }}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            {title}
          </Typography>
        </Box>

        <Box
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
          }}
        >
          <CustomButton variant="outlined" onClick={onClose}>
            {closeLabel}
          </CustomButton>
        </Box>
      </Box>
    </DialogTitle>
  );
};

export default StatisticsDialogTitle;
